import { action } from 'easy-peasy';
import { IActionSetCarePlanInterventions } from '../types';

const setCarePlanInterventions: IActionSetCarePlanInterventions = action((state, payload) => {
  state.items = payload;
});

export default setCarePlanInterventions;
